import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-magma-dom';

const AlertPanel = props => {
  return (
    <Alert
      variant={props.variant}
      testId="alertPanel"
      className={props.className}
    >
      {props.errMsg}
    </Alert>
  );
};

AlertPanel.defaultProps = {
  variant: 'info'
};

AlertPanel.propTypes = {
  errMsg: PropTypes.string.isRequired,
  variant: PropTypes.string,
  className: PropTypes.string
};

export default AlertPanel;
